import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { HTTP } from "../../api/http-common";
import { useGlobalContext } from "../../component/GlobalContext";

function PaymentSuccess() {
  const navigate = useNavigate();
  const { globalUserVar,setGlobalUserVar,isAuthenticated,setIsAuthenticated } = useGlobalContext();
  
  const logOutHandler = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate('/');
    // window.location.reload()
  }

  const handleSubmit = async () => {
        try {
          const payment_session_id = localStorage.getItem("payment_session_id");
          let fields = {
            payment_session_id: payment_session_id,
          };
  
          await HTTP.post(
            "/user/login/bysessionid",
            fields,
            // config
          )
            .then(async (response) => {
              if (response.status === 200) {
                localStorage.setItem('access_token', response.data.access_token);
                localStorage.setItem('refresh_token', response.data.refresh_token);
                localStorage.setItem('access_token_expires', response.data.access_token_expires)
                fetchUserData()
                // navigate('/account-details');
              }
            })
            .catch((error) => {
              if (error.response.status === 406) {
                // resetValidationErrors();
                // setPasswordError(error.response.data.detail);
              }
              if (error.response.status === 401) {
                Swal.fire({
                  title: 'Error!',
                  text: 'You are already registered!',
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
              }
              // setError(error);
              // setRerenderFlag(true);
              // loadAaMasterData();
              // resetValidationErrors();
            });
  
          // setIsLoading(false);
        } catch (error) {
          // setError(error);
          // setRerenderFlag(true);
          // setIsLoading(false);
        }
    };
    const fetchUserData = () => {
        const access_token = localStorage.getItem('access_token');
        const config = {
          headers: { 'Content-Type': 'application/json', 'token': access_token },
        };
        HTTP.get("user/me", config, config)
          .then((response) => {
            if (response.status === 200) {
              localStorage.setItem('userObj', JSON.stringify(response.data));
              setGlobalUserVar(JSON.stringify(response.data))
              setIsAuthenticated(true)
              localStorage.setItem('user_id', response.data.id);
              navigate('/account-details');
            }
          })
          .catch((error) => {
            console.log(error);
    
          });
      };
  useEffect(() => {
    Swal.fire({
      title: "Payment completed successfully!",
      // text: "If you're already signed in, please sign out and sign back in",
      icon: "success"
    }).then((result) => {
      const payment_session_id = localStorage.getItem("payment_session_id");
      // alert(payment_session_id)
      if (result.isConfirmed && payment_session_id != '') {
          // alert('here');
          handleSubmit();
        
      }else if(result.isConfirmed){
        // alert('payment_session_id')
        // logOutHandler()
      }else{
        // if (isAuthenticated) {
        //   navigate('/account-details');
        // }
        // alert('else')
        // logOutHandler();
      }
    });
  }, []);
  return (
    <div>Payment Succeed</div>
  )
}

export default PaymentSuccess